import api from './api';

/**
 * Phase 2 Step 8 — AI service wrapper.
 * All methods return null / throw on failure; callers should hide UI gracefully.
 */
const aiService = {
  status: () => api.get('/ai/status'),

  getCoaching: (sessionId, participantId) =>
    api.get(`/ai/coach/${sessionId}/${participantId}`),

  getActionPlanCoaching: (sessionId, participantId, planIndex) =>
    api.get(`/ai/coach/${sessionId}/${participantId}/action-plan/${planIndex}`),

  getScenarioCoaching: (sessionId, participantId, scenario) =>
    api.post(`/ai/coach/${sessionId}/${participantId}/scenario`, { scenario }),

  getCapabilityGaps: () =>
    api.get('/ai/analytics/capability-gaps'),

  getRecommendations: () =>
    api.get('/ai/analytics/recommendations'),

  // Phase 2 Step 10: authed via managerCode, not participantId
  getManagerInsights: (managerCode) =>
    api.get(`/ai/manager/${managerCode}/insights`),
};

export default aiService;
